import DatetimeUtils from "../../gd/utils/datetime-utils";
import {Cover, CoverPosition} from "../task/properties/cover";
import {CoverType} from "../../gd-components/cover/cover-type";

interface DocumentPropertiesConfig {
    lastOpened? : {[userId: string]: string}
    pages?      : number
    cover?      : {
        type        : CoverType
        id?         : ID                // is used for CoverType.GALLERY only
        url         : string
        thumbnail?  : string            // is used for CoverType.GALLERY only
        position    : CoverPosition
    }
}


export default class DocumentProperties {

    public lastOpened   : {[userId: string]: Moment}
    public pages        : number
    public cover?       : Cover

    constructor(data:DocumentPropertiesConfig) {

        // init last opened
        this.lastOpened = {}
        data && _.mapKeys(data.lastOpened, (datetime, userId)=>{
            this.lastOpened[userId] = DatetimeUtils.datetimeToMoment(datetime)
        })

        this.pages      = _.get(data,'pages',1)

        const cover = _.get(data,'cover', undefined)
        if (cover) this.cover = new Cover(cover)
    }

    get lastViewed():Moment|null {
        if (this.lastOpened[gd.user.id]) {
            return this.lastOpened[gd.user.id]
        }
        return null
    }

    toJSON() {
        const result: any = {}

        if (this.cover) result.cover = this.cover.toJSON()

        return result
    }
}
